import axios from 'axios';
import usedeletedata from '../../Hooks/useDeleteData';
import usegetdata from '../../Hooks/useGetData';
import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import { UpdateDatawithimage, UpdateProductdata } from '../../Hooks/useUpdateData';
import { Notify } from '../../Utility/Notify';
import {
  Add_New_users,
  Assign_Leads_Admin_Marketer,
  AssignleadinteamleaderType,
  DashboardForManager_CRMData_Type,
  DashboardForManager_Type,
  Delete_User,
  Get_All_Leads_For_Role_By_email_MarketerLeads_Type,
  Get_All_Leads_For_Role_By_email_Type,
  Get_ALL_Stages_With_LeadsCount_For_Admin,
  Get_ALL_Stages_With_LeadsCount_For_Marketer,
  Get_ALL_Stages_With_LeadsCount_For_Marketer_CRM_DATA,
  Get_All_Top_Saler,
  Get_All_users,
  Get_All_users_Depending_on_Sales,
  Get_Error,
  Get_One_Client,
  Get_sales_dashboard_Advanced,
  recieveusertoleadtype,
  SALES_LEADS_REPORT_LOADING,
  SALES_LEADS_REPORT_SUCCESS,
  Update_Client,
  UpdateStage,
  SalesRequestData_Type,
  GetAll_SalesRequestData_Type,
  
} from '../Types';

//get all data client action

// export const Getalldata=()=>async(dispatch)=>{
//     try{
// const res=await usegetdata(`api/v1/users?leadisactive=true`)

// dispatch({
//     type:Get_All_users,
//     payload:res,
// })
//     }
//     catch(e)
//     {
//         dispatch({
//             type:Get_Error,
//             payload:e+"error",
//         })
//     }
// }

export const Getalldatasearch = (quary) => async (dispatch) => {
  try {
    const res = await usegetdata(`api/v1/users/leads-with-stages?${quary}`);

    dispatch({
      type: Get_All_users,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

export const Getalldatasearch2 = (quary) => async (dispatch) => {
  try {
    const res = await usegetdata(`api/v1/users/admin/lead?${quary}`);

    dispatch({
      type: Get_All_users,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

// get all leads dublicated in admin dashboard
export const Getallleadsdublicatedinadmindashboard = () => async (dispatch) => {
  try {
    const res = await usegetdata(`api/v1/users/dublicatedLeads_Admin`);

    dispatch({
      type: Get_All_users,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

export const Getallleadsnotacivateddata = () => async (dispatch) => {
  try {
    const res = await usegetdata(`api/v1/users?leadisactive=false`);

    dispatch({
      type: Get_All_users,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

// For Admin Dashboard
export const GetallStagesWithLeadsCount_For_Admin_Dashboard_Action = () => async (dispatch) => {
  try {
    const res = await usegetdata(`api/v1/users/stage-statistics`);

    dispatch({
      type: Get_ALL_Stages_With_LeadsCount_For_Admin,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

// crm data dashboard quicknumbers
export const GetallStagesWithLeadsCount_For_Admin_Dashboard_Action_CRM_Data =
  () => async (dispatch) => {
    try {
      const res = await usegetdata(`api/v1/users/stage-statistics-CRM-DATA`);

      dispatch({
        type: Get_ALL_Stages_With_LeadsCount_For_Admin,
        payload: res,
      });
    } catch (e) {
      dispatch({
        type: Get_Error,
        payload: e + 'error',
      });
    }
  };

// For Marketere Dashboard
export const GetallStagesWithLeadsCount_For_Marketer_Dashboard_Action =
  (addby) => async (dispatch) => {
    try {
      const res = await usegetdata(`api/v1/users/stages-with-duplicate-by-addedby/${addby}`);

      dispatch({
        type: Get_ALL_Stages_With_LeadsCount_For_Marketer,
        payload: res,
      });
    } catch (e) {
      dispatch({
        type: Get_Error,
        payload: e + 'error',
      });
    }
  };

// crm data dashboard marketer quicknumbers
export const GetallStagesWithLeadsCount_For_Marketer_CRM_DATA_Dashboard_Action =
  (addby) => async (dispatch) => {
    try {
      const res = await usegetdata(
        `api/v1/users/stages-crm-data-with-duplicate-by-addedby/${addby}`,
      );

      dispatch({
        type: Get_ALL_Stages_With_LeadsCount_For_Marketer_CRM_DATA,
        payload: res,
      });
    } catch (e) {
      dispatch({
        type: Get_Error,
        payload: e + 'error',
      });
    }
  };

// get all Leads depending on sales
export const Getalldata_Leads_depending_on_Sales_Action = (salesid) => async (dispatch) => {
  dispatch({ type: 'LOADING_START' }); // إضافة حالة تحميل

  try {
    const res = await usegetdata(`api/v1/users/Get_Leads_By_Sales_id/${salesid}`);

    if (!res || !res.data) {
      throw new Error('No data received from server');
    }

    dispatch({
      type: 'Get_All_users_Depending_on_Sales',
      payload: Array.isArray(res.data) ? res.data : [res.data],
    });
  } catch (error) {
    console.error('Error in Getalldata_Leads_depending_on_Sales_Action:', error);

    dispatch({
      type: 'Get_Error',
      payload: error.response?.data?.message || error.message || 'Something went wrong',
    });
  } finally {
    dispatch({ type: 'LOADING_END' }); // إنهاء حالة التحميل
  }
};
//get all data client action

export const GetalldataLeadsWithPages = (page, limit) => async (dispatch) => {
  try {
    const res = await usegetdata(`api/v1/users?page=${page}&limit=${limit}`);

    dispatch({
      type: Get_All_users,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

//insert client action

// export const InsertuserData=(body)=>async(dispatch)=>{
//     try{
// const res=await useinsertdatawithoutimage(`/api/v1/users`,body)

// dispatch({
//     type:Add_New_users,
//     payload:res,
// })
//     }
//     catch(e)
//     {
//         dispatch({
//             type:Get_Error,
//             payload:e+"error",
//         })
//     }
// }

export const InsertuserData = (body) => async (dispatch) => {
  try {
    console.log('🔄 InsertuserData action called with body:', body);

    const res = await useinsertdatawithoutimage(`/api/v1/users`, body);

    console.log('✅ InsertuserData success response:', res);

    dispatch({
      type: Add_New_users,
      payload: res,
    });

    // ⭐⭐ إرجاع الـ response للمكون الأمامي
    return {
      success: true,
      payload: res,
      error: null,
    };
  } catch (e) {
    console.error('❌ Error in InsertuserData action:', e);
    console.error('❌ Error response:', e.response?.data);
    console.error('❌ Error status:', e.response?.status);

    dispatch({
      type: Get_Error,
      payload: e,
    });

    // ⭐⭐ إرجاع الـ error للمكون الأمامي
    return {
      success: false,
      payload: null,
      error: e,
      errorData: e.response?.data,
      status: e.response?.status,
    };
  }
};

//delete client action

export const DeleteUserAction = (id) => async (dispatch) => {
  try {
    const res = await usedeletedata(`/api/v1/users/${id}`);

    dispatch({
      type: Delete_User,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

//update client action
export const UpdateClientAction = (id, formatdata) => async (dispatch) => {
  try {
    // const res=await UpdateDatawithimage(`/api/v1/users/${id}`,formatdata)
    const res = await UpdateProductdata(`api/v1/users/${id}`, formatdata);

    dispatch({
      type: Update_Client,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//update client action
export const UpdateClientActionToReaciveusertolead = (id, formatdata) => async (dispatch) => {
  try {
    // const res=await UpdateDatawithimage(`/api/v1/users/${id}`,formatdata)
    const res = await UpdateProductdata(
      `/api/v1/users/updateandreciveusertolead/${id}`,
      formatdata,
    );

    dispatch({
      type: recieveusertoleadtype,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

export const AssignLeadsMarketerAndAdminAction =
  (leadId, userId, salesId, clearHistory, stage, assigntype, resetcreationdate, hidesalesnameonleadcomments) =>
  async (dispatch) => {
    try {
      const res = await UpdateProductdata(
        `api/v1/users/leads/assign/${leadId}/${userId}/${salesId}`,
        { clearHistory, stage, assigntype, resetcreationdate,hidesalesnameonleadcomments},
      );

      dispatch({
        type: Assign_Leads_Admin_Marketer,
        payload: res,
      });
    } catch (e) {
      dispatch({
        type: Get_Error,
        payload: e.res,
      });
    }
  };

export const bulkAssignLeadsAction =
  (leadIds, userId, salesId, clearHistory, stage) => async (dispatch) => {
    try {
      const res = await UpdateProductdata(`api/v1/users/leads/bulk-assign`, {
        leadIds,
        userId,
        salesId,
        clearHistory,
        stage,
      });

      dispatch({
        type: Assign_Leads_Admin_Marketer,
        payload: res.data,
      });

      // إشعار بالنجاح في الـ UI
      //   toast.success(`تم إسناد ${res.data.stats.assigned} عميل بنجاح`);

      return res;
    } catch (e) {
      dispatch({
        type: Assign_Leads_Admin_Marketer,
        payload: e.response?.data || { message: 'خطأ في الإسناد' },
      });

      //   toast.error(e.response?.data?.message || 'حدث خطأ في الإسناد');
      throw e;
    }
  };

// 2. الإكشن المتقدم للـ Bulk Assignment

export const AssignleadsinteamleaderAction =
  (leadId, userId, salesId, clearHistory, stage) => async (dispatch) => {
    try {
      // استدعاء API لتحديث الـ lead
      const res = await UpdateProductdata(
        `/api/v1/users/assign/simple/${leadId}/${userId}/${salesId}`,
        { clearHistory, stage },
      );

      dispatch({
        type: AssignleadinteamleaderType,
        payload: res,
      });
    } catch (e) {
      dispatch({
        type: Get_Error,
        payload: e.response, // تعديل من e.res إلى e.response
      });
    }
  };

//update client action
export const GetOneClientAction = (id) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/users/${id}`);

    dispatch({
      type: Get_One_Client,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

//updatestage
export const UpdateStageToLeed = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/users/${id}`, body);

    dispatch({
      type: UpdateStage,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

export const GetAllLeadsSearchAction = (quarystring) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/users?${quarystring}`);
    dispatch({
      type: Get_All_users,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

// Top Seller this month

export const Get_All_Top_Saller_Action = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/users/sales-performance`);
    dispatch({
      type: Get_All_Top_Saler,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

// get all leads by marketer user
export const Get_All_Leads_By_Email_User_Marketer_email_Action = (query) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/users/GetAllLeadsAddedByUser?${query}`);
    dispatch({
      type: Get_All_Leads_For_Role_By_email_MarketerLeads_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

export const Get_All_Leads_By_Email_User_Marketer_email_Action2 = (query) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/users/GetAllLeadsAddedByUser-advanced?${query}`);
    dispatch({
      type: Get_All_Leads_For_Role_By_email_MarketerLeads_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

export const Get_All_Leads_By_Email_User_Marketer_CRMDATA_email_Action2 =
  (query) => async (dispatch) => {
    try {
      const res = await usegetdata(
        `/api/v1/users/GetAllLeadsAddedByUser-crmdata-advanced?${query}`,
      );
      dispatch({
        type: Get_All_Leads_For_Role_By_email_MarketerLeads_Type,
        payload: res,
      });
    } catch (e) {
      dispatch({
        type: Get_Error,
        payload: e + 'error',
      });
    }
  };

// get all leads Dublicated For marketer user
export const Get_All_Leads_Dublicated_By_Email_User_Marketer_email_Action =
  (userId) => async (dispatch) => {
    try {
      const res = await usegetdata(`/api/v1/users/duplicates-by-email/${userId}`);
      dispatch({
        type: Get_All_Leads_For_Role_By_email_MarketerLeads_Type,
        payload: res,
      });
    } catch (e) {
      dispatch({
        type: Get_Error,
        payload: e + 'error',
      });
    }
  };

// top sales by quarter هتلاقيها في ال sales action

// reports
// في ملف UsersAction.js

export const getsalespreformancereportaction = (query) => async (dispatch) => {
  try {
    // بناء الـ URL مع الـ query parameters
    const queryString = new URLSearchParams(query).toString();
    const url = `api/v1/users/performance?${queryString}`;

    console.log('📡 API URL:', url);

    const res = await usegetdata(url);

    dispatch({
      type: Get_All_users,
      payload: res,
    });

    return res; // عشان تقدر تستخدم الـ response في الـ component
  } catch (e) {
    console.error('❌ Error in getsalespreformancereportaction:', e);

    dispatch({
      type: Get_Error,
      payload: e.response?.data?.message || e.message || 'حدث خطأ في جلب التقرير',
    });

    throw e; // عشان تعرف تتعامل مع الـ error في الـ component
  }
};

// تعديل الاكشن
export const Getdonedealreportadvancedaction =
  (salesId, page = 1, limit = 10, year = new Date().getFullYear()) =>
  async (dispatch) => {
    try {
      console.log('📤 Sending to backend:', { salesId, page, limit, year });

      // بناء الـ URL مع كل الـ query parameters
      const url = `/api/v1/users/leads-with-donedeal-report/${salesId}?page=${page}&limit=${limit}&year=${year}`;

      console.log('📤 URL:', url);

      const res = await usegetdata(url);

      console.log('📥 Backend response:', {
        success: res?.success,
        yearInfo: res?.yearInfo,
        highestDeal: res?.highestDeal,
        statistics: res?.statistics,
        leadsCount: res?.leads?.data?.length,
      });

      dispatch({
        type: Get_All_users,
        payload: res,
      });
    } catch (e) {
      console.error('❌ Error fetching report:', e);
      dispatch({
        type: Get_Error,
        payload: e + 'error',
      });
    }
  };

// في الـ Action file
// export const getSalesLeadsReportBetweenDates = (
//   creationDateFrom,
//   creationDateTo,
//   page = 1,
//   limit = 10,
//   salesPage = 1,
//   salesLimit = 10
// ) => async (dispatch) => {
//   try {
//     console.log('🚀 Starting getSalesLeadsReportBetweenDates action');
//     console.log('📅 Parameters:', {
//       creationDateFrom,
//       creationDateTo,
//       page,
//       limit,
//       salesPage,
//       salesLimit
//     });

//     // إضافة dispatch للتحميل
//     // dispatch({
//     //   type: SALES_LEADS_REPORT_LOADING,
//     //   payload: true
//     // });

//     // بناء الـ URL
//     const baseUrl = '/api/v1/users/salesreport-withleads-betweentwodates-creationdate';
//     const url = `${baseUrl}?creationDateFrom=${encodeURIComponent(creationDateFrom)}&creationDateTo=${encodeURIComponent(creationDateTo)}&page=${page}&limit=${limit}&salesPage=${salesPage}&salesLimit=${salesLimit}`;

//     console.log('🔗 URL:', url);

//     // إرسال الطلب
//     const res = await usegetdata(url);

//     console.log('📥 Full Response:', {
//       response: res,
//       data: res?.data,
//       status: res?.status,
//       statusText: res?.statusText
//     });

//     // تحقق من الـ response
//     if (!res) {
//       throw new Error('لا يوجد رد من السيرفر');
//     }

//     // استخراج البيانات - أهم جزء!
//     const responseData = res.data || res;

//     console.log('✅ Response Data:', {
//       success: responseData?.success,
//       message: responseData?.message,
//       hasData: !!responseData?.data,
//       dataLength: responseData?.data?.length,
//       salesPagination: responseData?.salesPagination
//     });

//     if (!responseData) {
//       throw new Error('لا توجد بيانات في الرد');
//     }

//     // **هنا الإصلاح - استخدم type واضح**
//     dispatch({
//       type: SALES_LEADS_REPORT_SUCCESS,
//       payload: responseData
//     });

//     return responseData;

//   } catch (error) {
//     console.error('❌ Error in action:', {
//       message: error.message,
//       response: error.response?.data,
//       status: error.response?.status
//     });

//     dispatch({
//       type: Get_Error,
//       payload: error.response?.data?.message || error.message || "حدث خطأ في جلب التقرير"
//     });

//     throw error;
//   } finally {
//     // إيقاف التحميل
//     dispatch({
//       type: SALES_LEADS_REPORT_LOADING,
//       payload: false
//     });
//   }
// };

export const Get_Dashboard_data_For_Mangers = (email) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/users/stage-Dashboard-Manager/${email}`);

    dispatch({
      type: DashboardForManager_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

export const Get_Dashboard_data_For_Mangers_crm_data = (email) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/users/stage-Dashboard-Manager-crmdata/${email}`);

    dispatch({
      type: DashboardForManager_CRMData_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};



















export const Sales_Request_Data_Limit_Action = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/users/sales/request-leads-from-data`, body);

    dispatch({
      type: SalesRequestData_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};



















export const GetAll_Sales_Request_Data_Limit_Action = (quarystring) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/users/sales/request-leads-from-data?${quarystring}`);

    dispatch({
      type: GetAll_SalesRequestData_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};
















